export default {"src":"/_next/static/media/M.edc6d2ab.svg","height":18,"width":18};